export default __webpack_public_path__ + "static/SRF 4220 - Fiche de spécifications et données techniques-d7dfe8df29bc7e89113278d4cde84bb4.pdf";